/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ea-no-data[_ngcontent-%COMP%]{position:absolute;top:30%}.ea-no-data[_ngcontent-%COMP%]   .ea-no-activity-data-icon[_ngcontent-%COMP%]{display:inline-block;height:80px;width:80px}.ea-no-data[_ngcontent-%COMP%]   .ea-no-activity-data-icon[_ngcontent-%COMP%]::after{content:\"\";background:url(ic-no-activities.1c2ee4b019f9f5cda25f.svg) no-repeat;position:absolute;left:calc(50% - 40px);height:80px;width:80px}.ea-no-data[_ngcontent-%COMP%]   .ea-no-data-text[_ngcontent-%COMP%]{white-space:pre-wrap}"];
export { styles as styles };
